import { render } from "./BasePageHeader.vue?vue&type=template&id=b79fe246&scoped=true"
const script = {}

import "./BasePageHeader.vue?vue&type=style&index=0&id=b79fe246&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\wordpress\\zens\\wp-content\\themes\\io.corporate-zens-adventkalender\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b79fe246"]])

export default __exports__